export default __webpack_public_path__ + "static/media/Mutual___ic_calender.f7cab5f4.svg";